import { Dispatch, SetStateAction } from 'react';

import { IOffersFragment } from 'generated/graphql-gateway';
import { IAppliedOffer } from 'generated/rbi-graphql';
import { IncentiveEvaluationMap } from 'state/loyalty/hooks/types';
import { ICart } from 'state/loyalty/in-restaurant-redemption';
import { LoyaltyOffer } from 'state/loyalty/types';

export type ReduceOffers = ({
  cmsOffers,
  baseOffers,
  appliedOffers,
  inRestaurantRedemptionCart,
  checkLoyaltyOfferAvailability,
  enableSortOffersForServiceMode,
  setOffersFeedbackMap,
  userOfferAttributes,
}: {
  cmsOffers: LoyaltyOffer[];
  personalizedOffers: LoyaltyOffer[];
  baseOffers: IOffersFragment[];
  appliedOffers: IAppliedOffer[];
  inRestaurantRedemptionCart: ICart;
  checkLoyaltyOfferAvailability: (offer: LoyaltyOffer) => boolean;
  enableSortOffersForServiceMode: boolean;
  setOffersFeedbackMap: Dispatch<SetStateAction<IncentiveEvaluationMap | null>>;
  userOfferAttributes: IUserOfferAttributes | undefined;
}) => LoyaltyOffer[][];

export interface IUserOfferAttributes {
  userBatteryLevel?: number;
  dobDeleted?: string | boolean;
  phoneNumberVerified?: boolean;
  promotionalEmails?: boolean;
  zipcode?: string;
  hasDeliveryAddress?: boolean;
  favoriteStores?: (string | undefined)[] | null;
  favoriteOffers?: string[] | null;
}

export enum OffersServiceMode {
  PICKUP_ONLY = 'pickUpOnly',
  DELIVERY_ONLY = 'deliveryOnly',
}

export enum AvailableTabsType {
  AllOffers = 'AllOffers',
  Favorites = 'Favorites',
  ExternalOffers = 'ExternalOffers',
}

export enum AvailableTabs {
  AllOffers,
  Favorites,
}

export enum OfferStatus {
  Available = 'Available',
  Locked = 'Locked',
  ComingSoon = 'Coming Soon',
}
